import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import ScrollSpyProvider from '@di-shared/features/common/ScrollSpyProvider';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import ImageSelector from '@di-shared/features/common/ImageSelector';
import {useEnvironmentStore} from '@di-shared/features/environment/environmentStore';
import {BrandType, RegionType} from '@shared/cci/features/const/environment';
import DataExploreContents from '@di-shared/features/about/DataExplore/DataExploreContents';
import {ccWebviewUtils} from '@shared/cci/features/webviewUtils';
import {ROUTE_PATHS} from '@di-shared/routes';
import {Trans} from 'react-i18next';
import useCcWebviewUtilsHelper from '@di-shared/features/common/useCcWebviewUtilsHelper';

const HEADER_HEIGHT = -130;

function AboutDataExplorePage(): JSX.Element {
  const brand = import.meta.env.VITE_BRAND;
  const {t} = useInferableTranslation();
  const {backOrClose} = useCcWebviewUtilsHelper();
  const {region, vin} = useEnvironmentStore(({region, vin}) => ({region, vin}));
  const {openInAppBrowser} = useCcWebviewUtilsHelper();

  function openVehicleDeleteBottomSheet(vin: string) {
    ccWebviewUtils.openBottomSheetWebViewUrl(ROUTE_PATHS.BOTTOM_SHEET_VEHICLE_DELETE.getFullPath(), {vin});
  }

  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header
        className="header_with_tab"
        left={<HeaderBackButton />}
      >
        <h1 className="headline_xxsmall nav_center_title">{t(region === RegionType.KR ? 'T20094' : 'msg_knowing_data_title')}</h1>
      </Header>
      <main className="content page_setting">
        <section className="section">
          <div
            className="section_heading type_main"
            style={{whiteSpace: 'pre-wrap'}}
          >
            <h2 className="section_heading_title">{t(region === RegionType.KR ? 'T40000' : 'msg_knowing_data_01')}</h2>
            <p className="section_heading_desc">{t(region === RegionType.KR ? 'T40001' : 'msg_knowing_data_02')}</p>
          </div>
          <div className="section_visual">
            <ImageSelector
              className="section_visual_img"
              alt="section_visual_img"
              kiaLightSrc={() => import('@di-shared/assets/img/visual/data_explore.png')}
              kiaDarkSrc={() => import('@di-shared/assets/img/visual/data_explore.png')}
              hyundaiLightSrc={() => import('@di-shared/assets/img/visual/hyundai/data_explore.png')}
              hyundaiDarkSrc={() => import('@di-shared/assets/img/visual/hyundai/data_explore.png')}
              genesisLightSrc={() => import('@di-shared/assets/img/visual/genesis/data_explore.png')}
              genesisDarkSrc={() => import('@di-shared/assets/img/visual/genesis/data_explore.png')}
            />
          </div>
        </section>
        <ScrollSpyProvider
          isHash
          scrollOffset={HEADER_HEIGHT}
        >
          <DataExploreContents />
        </ScrollSpyProvider>
        <div className="divider divider_thick" />
        <section className="section section_notice">
          {region === RegionType.KR ? (
            <ul className="notice_list">
              <li
                className="notice_item"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T40003')}
              </li>
              {brand !== BrandType.KIA && (
                <li
                  className="notice_item"
                  style={{whiteSpace: 'pre-wrap'}}
                >
                  <Trans
                    i18nKey="T40002"
                    components={{
                      Highlighted: (
                        <a
                          href="#"
                          role="button"
                          className="notice_link"
                          onClick={(e) => {
                            e.preventDefault();
                            openInAppBrowser(import.meta.env.VITE_PRIVACY_URL);
                          }}
                        />
                      ),
                    }}
                  />
                </li>
              )}
              {/* 국내 기아에만 적용되는 스펙 (차량 삭제) */}
              {brand === BrandType.KIA && vin && (
                <li className="notice_item">
                  <Trans
                    i18nKey="T20342"
                    components={{
                      Highlighted: (
                        <a
                          role="button"
                          className="notice_link"
                          target="_blank"
                          onClick={(e) => {
                            e.preventDefault();
                            openVehicleDeleteBottomSheet(vin);
                          }}
                        />
                      ),
                    }}
                  />
                </li>
              )}
            </ul>
          ) : (
            <ul className="notice_list">
              <li
                className="notice_item"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('msg_knowing_data_04')}
              </li>
            </ul>
          )}
        </section>
      </main>
      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          onClick={() => backOrClose()}
        >
          {t(region === RegionType.KR ? 'T10114' : 'ctn_knowing_data_05')}
        </button>
      </div>
    </div>
  );
}

export default AboutDataExplorePage;
